import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { formatDate, formatToZMW, handlePrint, rootUrl } from '../../../helpers';
import { useAuth } from '../../../context/auth-context';
import { FaPrint, FaSpinner, FaToggleOff, FaToggleOn } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Select from "react-select";

const Payments = ({startDate, endDate, rdata, triggerFetch}) => {
  const [cashData, setCashData] = useState([]);
  const [cashBooks, setCashBooks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toggle, setToggle] = useState(false);

  useEffect(()=>{
    console.log(cashBooks)
  }, [cashBooks])

  const {allData, setAllData} = useOutletContext();
  const auth = useAuth();

  const bankOptions = allData?.bank.map((bank) => {
    return {
      value: bank.id,
      label: bank.name,
    };
  });

  const [columnVisibility, setColumnVisibility] = useState({
    accountCode: true,
    accountName: true,
    totalBudget: true,
    flexed: true,
    actual: true,
    actualToDate: true,
    performance: true,
    difference: true,
    budgetPerformance: true,
  });



  const componentRef = useRef(null)

  function getMonthDifference(startDate, endDate) {
    let start = new Date(startDate);
    let end = new Date(endDate);
    
    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();

    return years * 12 + months;
}

  // Dynamic function to build accountCodesAndNames array
  const buildAccountCodesAndNames = (allData, startDate) => {
    if (!allData?.budget || !allData?.coa) {
      return [
        { id: "1", name: "" },
        { id: "111", name: "Total" },
        { id: "2", name: "" },
        { id: "3", name: "" },
        { id: "4", name: "" },
        { id: "5", name: "" },
        { id: "6", name: "" },
        { id: "000", name: "Rest" },
      ];
    }

    let start = new Date(startDate);
    const yr = start.getFullYear();
    
    // Get all unique COAs for the year
    const accounts = [...new Set(allData.budget.filter(a => a.year == yr).map(item => item.coa))];
    
    // Get unique first digits from COAs
    const firstDigits = [...new Set(accounts.map(coa => coa?.toString().charAt(0)).filter(Boolean))];
    
    // Categorize first digits as revenue or expense based on COA type
    const revenueDigits = [];
    const expenseDigits = [];
    
    firstDigits.forEach(digit => {
      // Find all COAs that start with this digit
      const coasWithDigit = accounts.filter(coa => coa?.toString().charAt(0) === digit);
      
      // Check if any COA with this first digit is revenue
      let isRevenue = false;
      let isExpense = false;
      
      coasWithDigit.forEach(coa => {
        const coaRecord = allData.coa?.find(item => item.account === coa);
        if (coaRecord) {
          const isAsset = coaRecord.type?.toLowerCase().includes("ass");
          const isLiability = coaRecord.type?.toLowerCase().includes("lia");
          
          // Check if revenue (not asset, not liability)
          if (!isAsset && !isLiability) {
            const type = coaRecord.type?.toLowerCase().includes("rev") ? "revenue" : "expense";
            if (type === "revenue") {
              isRevenue = true;
            } else {
              isExpense = true;
            }
          }
        }
      });
      
      // Add to appropriate category
      if (isRevenue && !revenueDigits.includes(digit)) {
        revenueDigits.push(digit);
      } else if (isExpense && !expenseDigits.includes(digit) && !revenueDigits.includes(digit)) {
        expenseDigits.push(digit);
      }
    });
    
    // Sort digits numerically
    revenueDigits.sort((a, b) => a - b);
    expenseDigits.sort((a, b) => a - b);
    
    // Build the array: revenue digits, "111" separator, expense digits, "000" at end
    const accountCodesAndNames = [
      ...revenueDigits.map(digit => ({ id: digit, name: "" })),
      { id: "111", name: "Total" },
      ...expenseDigits.map(digit => ({ id: digit, name: "" })),
      { id: "000", name: "Rest" },
    ];
    
    return accountCodesAndNames;
  };
  
  const sumOfArray = (arr) => arr.reduce((acc, num) => acc + num, 0);

  // Fetch data when triggerFetch changes (triggered by button in parent)
  useEffect(() => {
    if (triggerFetch && startDate && endDate) {
      setLoading(true);
      axios
        .get(rootUrl(`/getCashByDate/${auth.user?.cid}~${startDate}~${endDate}`))
        .then((response) => {
          const cash = response.data.data;
       
          setCashData(cash?.cash);
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching data', error);
          toast.error('Error fetching data');
          setLoading(false);
        });
    }
  }, [triggerFetch]);

  if (loading) {
    return <div className='flex justify-center items-center h-full w-full text-blue-950 text-5xl p-5 m-5 '>
            <FaSpinner size={50} className="spinner"  />
            </div>
  }

  const renderTableRows = () => {
    const rows = [];
    if(!allData.budget){
        return
    }

    let start = new Date(startDate);
    const yr = start.getFullYear()
    // const accounts = [...new Set(allData.budget.map(item => item.coa.substring(0, 3)))];
    const accounts = [...new Set(allData.budget.filter(a=>a.year == yr).map(item => item.coa))].sort((a, b) => a - b);
    
    // Build dynamic accountCodesAndNames array based on COA types
    const accountCodesAndNames = buildAccountCodesAndNames(allData, startDate);
  
    let months = getMonthDifference(startDate, endDate) + 1;

    let selectedMonth = new Date(endDate).getMonth()

    let totalBudgetg = 0;
    let totalFlexedg = 0;
    let totalActualg = 0;
    let totalActualToDateg = 0;
    let totalDifferenceg = 0;
    

    accountCodesAndNames.forEach((account) => {
      let totalBudget = 0;
      let totalBudgets = 0;
      let totalFlexed = 0;
      let totalActual = 0;
      let totalActualToDate = 0;
      let totalFlexedPerformance = 0;
      let totalDifference = 0;
      let totalBuggedPerformance = 0;


      accounts.forEach((accountCode) => {
        if (account.id === accountCode?.toString().substring(0, 1)) {
          const budgetEntries = allData.budget.filter(item => item.coa == accountCode);
          const coaEntries = allData.coa.filter(item => item.account == accountCode);
          totalBudget = sumOfArray(budgetEntries.filter(a=>a.year == yr).map(item => parseFloat(item.price * item.frequency * item.qty)));
          const flexed = (months / 12) * totalBudget;
          const coa = allData.coa.find(item => item.account == accountCode)?.id;
          const actual = cashBooks.length > 0? sumOfArray(
            cashData
              ?.filter(item => budgetEntries.some(entry => item.coa_id == entry.id) && cashBooks.includes(item.bank)) 
              .map(item => parseFloat(item.amount))
          )  : sumOfArray(
            cashData
              ?.filter(item => budgetEntries.some(entry => item.coa_id == entry.id)) 
              .map(item => parseFloat(item.amount))
          );

      

          const actualOne = cashBooks.length > 0
          ? sumOfArray(
              cashData
                ?.filter(item =>
                  budgetEntries.some(entry => item.coa_id == entry.id) &&
                  cashBooks.includes(item.bank) &&
                  new Date(item.date).getMonth() === selectedMonth
                )
                .map(item => parseFloat(item.amount))
            )
          : sumOfArray(
              cashData
                ?.filter(item =>
                  budgetEntries.some(entry => item.coa_id == entry.id) &&
                  new Date(item.date).getMonth() === selectedMonth
                )
                .map(item => parseFloat(item.amount))
            );
        

       
          if(totalBudget > 0 && !toggle){
            
            rows.push(
                <tr key={accountCode}>
                   {columnVisibility.accountCode && (
              <td className="border border-gray-300 py-2 px-2">{accountCode}</td>
                  )}
                   {columnVisibility.accountName && (
              <td className="border border-gray-300 py-2 px-2">{coaEntries[0]?.name}</td>
                  )}
                   {columnVisibility.totalBudget && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudget)}</td>
                  )}
                  {columnVisibility.flexed && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(flexed)}</td>
                  )}
                   {columnVisibility.actual && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(actualOne)}</td>
                  )}
                  {columnVisibility.actualToDate && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(actual)}</td>
                  )}
                   {columnVisibility.performance && (
              <td className="border border-gray-300 py-2 px-2">{((actual / flexed) * 100).toFixed()}%</td>
                  )}
                   {columnVisibility.difference && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudget - actual)}</td>
                  )}
                  {columnVisibility.budgetPerformance && (
              <td className="border border-gray-300 py-2 px-2">{((actual / totalBudget) * 100).toFixed()}%</td>
            )}
                </tr>
              );
          }
     
          totalBudgets += totalBudget;
          totalFlexed += flexed;
          totalActual += actualOne;
          totalActualToDate += actual;
          totalFlexedPerformance += (actual / flexed) * 100;
          totalDifference += totalBudget - actual;
          totalBuggedPerformance += (actual / totalBudget) * 100;
        }
      });


      if(totalBudget > 0){
        rows.push(
            <tr key={`${account.id}-total`} className={`${!toggle?'bg-gray-800 text-white':''} m-2 p-2`} >
            {columnVisibility.accountCode && (
            <td className="border border-gray-300 py-2 px-2">{account.id}</td>
            )}
            {columnVisibility.accountName && (
            <td className="border border-gray-300 py-2 px-2">{account.name}</td>
            )}
            {columnVisibility.totalBudget && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgets)}</td>
            )}
            {columnVisibility.flexed && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalFlexed)}</td>
            )}
            {columnVisibility.actual && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActual)}</td>
            )}
            {columnVisibility.actualToDate && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualToDate)}</td>
            )}
            {columnVisibility.performance && (
            <td className="border border-gray-300 py-2 px-2">{((totalActualToDate / totalFlexed) * 100).toFixed()}%</td>
            )}
            {columnVisibility.difference && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgets - totalActualToDate)}</td>
            )}
            {columnVisibility.budgetPerformance && (
            <td className="border border-gray-300 py-2 px-2">{((totalActualToDate / totalBudgets) * 100).toFixed()}%</td>
            )}
            </tr>
          );

        }

            totalBudgetg += totalBudgets
            totalFlexedg += totalFlexed;
            totalActualg += totalActual;
            totalActualToDateg += totalActualToDate;
            totalDifference += totalBudgetg - totalActualToDateg;
          

          if(account.id == "111"){
            rows.push(
              <tr key={`${account.id}-total`} className={`bg-blue-950 text-white m-2 p-2`} >
              {columnVisibility.accountCode && (
         <td colSpan={2} className='px-2 py-2 border border-gray-200'>{'Total Income'}</td>
             )}
              
              {columnVisibility.totalBudget && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg)}</td>
             )}
             {columnVisibility.flexed && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalFlexedg)}</td>
             )}
              {columnVisibility.actual && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualg)}</td>
             )}
             {columnVisibility.actualToDate && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualToDateg)}</td>
             )}
              {columnVisibility.performance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualToDateg / totalFlexedg) * 100).toFixed()}%</td>
             )}
              {columnVisibility.difference && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg - totalActualToDateg)}</td>
             )}
             {columnVisibility.budgetPerformance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualToDateg / totalBudgetg) * 100).toFixed()}%</td>
       )}
           </tr>
              );
              totalBudgetg = 0
              totalFlexedg = 0;
              totalActualg = 0;
              totalActualToDateg = 0;
              totalDifference = 0;
          }

          if(account.id == "000"){
            rows.push(
              <tr key={`${account.id}-total`} className={`bg-blue-950 text-white m-2 p-2`} >
              {columnVisibility.accountCode && (
         <td colSpan={2} className='px-2 py-2 border border-gray-200'>{'Total Expenditure'}</td>
             )}
              
              {columnVisibility.totalBudget && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg)}</td>
             )}
             {columnVisibility.flexed && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalFlexedg)}</td>
             )}
              {columnVisibility.actual && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualg)}</td>
             )}
             {columnVisibility.actualToDate && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualToDateg)}</td>
             )}
              {columnVisibility.performance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualToDateg / totalFlexedg) * 100).toFixed()}%</td>
             )}
              {columnVisibility.difference && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg - totalActualToDateg)}</td>
             )}
             {columnVisibility.budgetPerformance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualToDateg / totalBudgetg) * 100).toFixed()}%</td>
       )}
           </tr>
              );
              totalBudgetg = 0
              totalFlexedg = 0;
              totalActualg = 0;
              totalActualToDateg = 0;
              totalDifference = 0;
          }

        
      

    });

    return rows;
  };

  const handleColumnToggle = (column) => {
    setColumnVisibility((prev) => ({ ...prev, [column]: !prev[column] }));
  };

 



  return (
    <div className="cash-report">
      <h1 className='font-bold text-xl my-3'>Receipts and Payments By COA</h1>

        <Select
    options={bankOptions}
    placeholder="Banks"
    isClearable
    isMulti
    className='my-5 w-[50%]'
    value={bankOptions.filter(option => cashBooks.includes(option.value))}
    onChange={(selectedOptions) =>
      setCashBooks(selectedOptions ? selectedOptions.map(opt => opt.value) : [])
    }
  />


      
        <button className="bg-blue-950 text-white px-4 py-2 rounded" onClick={()=>setToggle(!toggle)}> 
          {
            toggle?<FaToggleOn size={20}/>:<FaToggleOff size={20}/>
          }
          </button>
          <div className="my-5 flex flex-wrap gap-4">
  {Object.keys(columnVisibility).map((column) => (
    <label
      key={column}
      className="flex items-center space-x-2 bg-gray-100 px-3 py-2 rounded-md shadow-sm hover:bg-gray-200"
    >
      <input
        type="checkbox"
        checked={columnVisibility[column]}
        onChange={() => handleColumnToggle(column)}
        className="form-checkbox h-4 w-4 text-blue-600 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
      />
      <span className="text-sm text-gray-700">{column}</span>
    </label>
  ))}
</div>

<button
      onClick={() => handlePrint(componentRef)}
      className="bg-blue-950 text-white px-4 py-2 rounded float-right"
    >
      <FaPrint/>
    </button>
<div ref={componentRef}>

<div className='text-center'>
              <h2 className='font-bold text-2xl'>{allData.council[0]?.name.toUpperCase()}</h2>
              <h2 className="font-bold text-2xl my-3">{'Receipts and Payments By COA'.toUpperCase()}</h2>
              <h3 className='text-xl font-bold'>From {formatDate(startDate)} to {formatDate(endDate)}</h3>
          </div>

      <table className="table-auto w-full border-collapse border border-gray-300 rounded-lg">
        <thead>
          {/* <tr className='bg-blue-950 text-white'>
            <th className="border border-gray-300 px-4 py-2">Account Code</th>
            <th className="border border-gray-300 px-4 py-2">Account Name</th>
            <th className="border border-gray-300 px-4 py-2">Total Budget</th>
            <th className="border border-gray-300 px-4 py-2">Flexed</th>
            <th className="border border-gray-300 px-4 py-2">Actual</th>
            <th className="border border-gray-300 px-4 py-2">Actual To Date</th>
            <th className="border border-gray-300 px-4 py-2">Flexed Performance</th>
            <th className="border border-gray-300 px-4 py-2">Difference</th>
            <th className="border border-gray-300 px-4 py-2">Budget Performance</th>
          </tr> */}
          <tr className='bg-blue-950 text-white'>
            {columnVisibility.accountCode && (
              <th className="border border-gray-300 py-2 px-2">Account Code</th>
            )}
            {columnVisibility.accountName && (
              <th className="border border-gray-300 py-2 px-2">Account Name</th>
            )}
            {columnVisibility.totalBudget && (
              <th className="border border-gray-300 py-2 px-2">Total Budget</th>
            )}
            {columnVisibility.flexed && (
              <th className="border border-gray-300 py-2 px-2">Flexed</th>
            )}
            {columnVisibility.actual && (
              <th className="border border-gray-300 py-2 px-2">Actual</th>
            )}
            {columnVisibility.actualToDate && (
              <th className="border border-gray-300 py-2 px-2">Actual to date</th>
            )}
            {columnVisibility.performance && (
              <th className="border border-gray-300 py-2 px-2">Actual Performance</th>
            )}
            {columnVisibility.difference && (
              <th className="border border-gray-300 py-2 px-2">Difference</th>
            )}
              {columnVisibility.budgetPerformance && (
              <th className="border border-gray-300 py-2 px-2">Budget Performance</th>
            )}
          </tr>
        </thead>
        <tbody>
          {renderTableRows()}
        </tbody>
      </table>
    </div>
    </div>
  );
};

export default Payments;
